import Immutable from 'immutable';
import { buildAnonymizer, getIsAnonymized } from 'edrolo/domains/anonymizer';
import * as profileUtils from './utils';

const profileAnonymizer = buildAnonymizer({
  seedResolver: 'user_id',
  schemaFields: [
    {
      key: 'display_name',
      type: 'full_name',
    },
  ],
});

export const getProfile = (state) => {
  // state.profile is fetched server-side from profile_server_data in account.html.
  // This is loaded from profiles.services.spa_context.fetch_profile_spa_context.
  const isAnonymized = getIsAnonymized(state);
  const profile = isAnonymized
    ? profileAnonymizer(state.profile)
    : state.profile;
  return profile || Immutable.Map();
};

export const getKeystore = (state) =>
  profileUtils.getKeystore(getProfile(state));

export const getKeystoreItem = (state, key) => getKeystore(state).get(key);
